import url from '../url'
import headers from '../headers'

export default {
	patients: {
		getAll (context, user_uid, size = 999) {
			return context.$http.get(
				`${url}/users/${user_uid}/groups/watches/?size=${size}`,
				headers.bearer()
			)
		},
		get (context, user_uid, group_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/groups/watches/${group_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/groups/watches/`,
				model,
				headers.bearer()
			)
		},
		edit (context, user_uid, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/groups/watches/${model.id}/`,
				model,
				headers.bearer()
			)
		},
		delete (context, user_uid, group_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/groups/watches/${group_id}/`,
				headers.bearer()
			)
		}
	},
	devices: {
		getAll (context, user_uid, size = 999) {
			return context.$http.get(
				`${url}/users/${user_uid}/groups/devices/?size=${size}`,
				headers.bearer()
			)
		},
		getAllAvailable (context, user_uid, size = 999) {
			return context.$http.get(
				`${url}/users/${user_uid}/groups/devices/available/?size=${size}`,
				headers.bearer()
			)
		},
		get (context, user_uid, group_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/groups/devices/${group_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/groups/devices/`,
				model,
				headers.bearer()
			)
		},
		edit (context, user_uid, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/groups/devices/${model.id}/`,
				model,
				headers.bearer()
			)
		},
		delete (context, user_uid, group_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/groups/devices/${group_id}/`,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/groups.js